import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetFrequency = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback((payload: { frequency: string }) => dispatch({ type: 'SET_FREQUENCY', payload }), [dispatch]);
};
